import { groupMoveUser } from "../../features/daoTrang/daoTrangSlice";

let dragTarget = {};
let dragContainer = {};

export function setDragging({user: user, container}) {
    dragTarget = user;
    dragContainer = container;
}
/*
group
name
members
*/
export function canMoveOrderTo(container) {
  try {
    return (dragContainer.group.id+dragContainer.name) !== (container.group.id +container.name)
  } catch(ex) {
    return false
  }
}
export function moveOrderTo(container, dispatch) {
  dispatch(groupMoveUser({dragContainer,dragUser: dragTarget,dropContainer: container}))
}

export function Overlay({ color }) {
  return (
    <div
      style={{
        position: "absolute",
        top: 0,
        left: 0,
        height: "100%",
        width: "100%",
        zIndex: 1,
        opacity: 0.5,
        backgroundColor: color,
      }}
    />
  );
}